/**
 * Content for the marketing /influencers, /for-hotels,
 * /for-travel-agents, /for-dmo pages — all rendered through
 * components/website/pages/BusinessPage.tsx.
 *
 * Single source of truth: WebsiteRoutes.tsx (SPA) and the SSR marketing
 * manifest both import these objects.
 */

import { DmoFeaturesContent } from "components/website/content/business/dmo/DmoFeatures";
import dmoHowItWorks from "components/website/content/business/dmo/dmoHowItWorks.json";
import { HotelFeaturesContent } from "components/website/content/business/hotels/HotelFeatures";
import hotelHowItWorks from "components/website/content/business/hotels/hotelHowItWorks.json";
import { InfluencerFeaturesContent } from "components/website/content/business/influencers/InfluencerFeatures";
import influencerHowItWorks from "components/website/content/business/influencers/InfluencerHowItWorks.json";
import { TravelAgentFeaturesContent } from "components/website/content/business/travelagents/TravelAgentFeatures";
import travelagentsHowItWorks from "components/website/content/business/travelagents/travelagentHowItWorks.json";

export const INFLUENCERS_CONTENT = {
	title: "A new way to inspire your followers",
	text: "Easily share the place you recommend with your followers and increase your revenue.",
	subtitle: "For influencers",
	usps: [
		"Share destination tips and recommendations easily",
		"Increase your following base",
		"Upscale your business model",
		"Boost reputation as a trusted travel resource  ",
	],
	color: "black",
	featureList: InfluencerFeaturesContent,
	howitworks: influencerHowItWorks,
	type: "influencer",
	form: "creator",
	pageTitle: "Stippl for Influencers",
};

export const HOTELS_CONTENT = {
	title: "Your Digital Hotel Concierge",
	text: "Easily share the place you recommend with your followers and increase your revenue.",
	subtitle: "For hotels",
	usps: [
		"Increased partnership revenue",
		"Enhanced guest experience",
		"Personalised mobile app for guests",
	],
	color: "black",
	featureList: HotelFeaturesContent,
	howitworks: hotelHowItWorks,
	type: "hotel",
	form: "business",
	signupType: "b2csignup",
	pageTitle: "Stippl for Hotels",
};

export const TRAVEL_AGENTS_CONTENT = {
	title: "Offer interactive itineraries to your customers",
	text: "Create beautiful itineraries that turn clients into brand ambassadors by providing a great travel experience.",
	subtitle: "For travel agents",
	usps: [
		"Turn clients into brand ambassadors",
		"Empower clients with the travel tools they need",
		"Increase bookings through your clientss social networks",
		"Create beautiful & inspiring itineraries with ease",
	],
	color: "black",
	featureList: TravelAgentFeaturesContent,
	howitworks: travelagentsHowItWorks,
	type: "travel-agent",
	form: "business",
	signupType: "b2csignup",
	pageTitle: "Stippl for Travel Agents",
};

export const DMO_CONTENT = {
	title: "A dynamic way of empowering tourists",
	text: "Easily share the place you recommend with your followers and increase your revenue.",
	subtitle: "For DMOs",
	usps: [
		"Stay present throughout the entire travel journey",
		"Easy to maintain, not a lot of time needed",
		"Stand out by promoting hidden gems at your destination",
	],
	color: "black",
	featureList: DmoFeaturesContent,
	howitworks: dmoHowItWorks,
	type: "dmo",
	form: "business",
	signupType: "b2csignup",
	pageTitle: "Stippl for DMOs",
};
